import ReportsQATable from './ReportsQATable';
export default ReportsQATable;